import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { DailyDeliveryStatus } from '@apps/carepartner/interfaces/daily_delivery'

import { getUsersDailyDeliveryStatus } from '@lib/query/queryFunction'

export const dailyDeliveryKeys = {
  all: ['daily_delivery'] as const,
  status: () => [...dailyDeliveryKeys.all, 'status'] as const,
}

export const useUsersDailyDeliveryStatus = (
  isAuthenticated: boolean
): UseQueryResult<(DailyDeliveryStatus | null)[]> => {
  return useQuery(dailyDeliveryKeys.status(), getUsersDailyDeliveryStatus(), {
    enabled: isAuthenticated,
  })
}
